<template>
    <div>
        <m-navbar :isWhiteLogo="article?article.isWhiteLogo:'false'"></m-navbar>
        <div v-if="article" class="container">
            <div class="img-container">
                <img v-if="$route.name==='news'" :src="baseUrl+article.headpic.url" alt="">
                <img v-if="$route.name==='aboutUs'" :src="baseUrl+article.media.url" alt="">
            </div>
            <div class="info-outer-container">
                <p class="title f-pdf-m">
                    {{article.title||article.name}}
                </p>
                <div class="decoration-line"></div>
                <p v-if="$route.name==='news'" class="display-time f-GOTHICB">Posted In Launch
                    On {{displayTime}}</p>
                <p class="description f-GOTHIC">{{article.description}}</p>
            </div>
            <div class="detail f-GOTHIC" v-html="article.content"></div>
            <go-back-to-top v-if="article.content" :isWindowScroll="true"></go-back-to-top>
            <div @click="goBack()" class="to-catalogue f-GOTHICB text-center">< To catalogue</div>
        </div>
    </div>
</template>

<script>
    import MNavbar from '@/components/MNavbar.vue'
    import {articleDataMixin} from '../mixins'
    import GoBackToTop from '@/components/GoBackToTop.vue'

    export default {
        name: "MArticle",
        components: {
            MNavbar,
            GoBackToTop
        },
        mixins: [articleDataMixin],
    }
</script>

<style scoped>
    .container {
        min-height: 100vh;
    }

    .to-catalogue {
        position: absolute;
        left: 23px;
        top: 101px;
        width: 188px;
        height: 41px;
        line-height: 41px;
        background-color: #ffffff;
        color: black;
        border-radius: 20px;
        cursor: pointer;
        z-index: 1;
    }

    .img-container {
        width: 100%;
        height: 525px;
    }

    .img-container img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
    }

    .info-outer-container {
        box-sizing: border-box;
        padding: 30px 30px 58px 30px;
        border-bottom: 2px solid black;
    }

    .title {
        font-size: 50px;
        line-height: 1;
    }

    .decoration-line {
        width: 129px;
        height: 4px;
        background-color: #00a496;
        margin: 40px 0;
    }

    .display-time {
        font-size: 24px;
        padding-bottom: 32px;
    }

    .description {
        font-size: 19px;
    }

    .detail {
        padding: 74px 30px 140px 30px;
    }

    .detail >>> h1, .detail >>> h2, .detail >>> h3, .detail >>> h4, .detail >>> h5, .detail >>> h6 {
        font-family: GOTHICB sans-serif;
        font-size: 36px;
        line-height: 2;
    }

    .detail >>> p {
        font-size: 18px;
        line-height: 34px;
        color: #707070;
    }

    .detail >>> img {
        max-width: 100%;
        height: auto;
        object-fit: contain;
    }

    .detail >>> iframe, .detail >>> video {
        width: 100%;
        height: 100%;
    }

    .loading {
        width: 100vw;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>